export default __webpack_public_path__ + "static/media/logotipo_black.d91ad1d0.svg";